import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import WelcomeVideo from './WelcomeVideo';

const AuthCheck = ({ children, user }) => {
  const [showWelcomeVideo, setShowWelcomeVideo] = useState(false);

  useEffect(() => {
    const checkWelcomeVideo = async () => {
      if (!user) return;
      
      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);
      
      if (!userDoc.exists() || !userDoc.data().hasSeenWelcomeVideo) {
        setShowWelcomeVideo(true);
      }
    };

    checkWelcomeVideo();
  }, [user]);

  const handleVideoComplete = async () => {
    if (!user) return;
    
    const userDocRef = doc(db, 'users', user.uid);
    await setDoc(userDocRef, { hasSeenWelcomeVideo: true }, { merge: true });
    setShowWelcomeVideo(false);
  };

  return (
    <>
      {showWelcomeVideo && <WelcomeVideo onComplete={handleVideoComplete} />}
      {children}
    </>
  );
};

export default AuthCheck; 